// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2SBYD","left":"InfoRow_left__1hzu6"};